var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccessDenied(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48.000000pt",
    height: "48.000000pt",
    viewBox: "0 0 48.000000 48.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,48.000000) scale(0.100000,-0.100000)",
    fill: "#ea2c2f",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185 414 c-27 -14 -68 -29 -90 -33 l-40 -7 1 -69 c1 -102 43 -170 151 -244 l33 -22 44 30 c102 71 150 156 144 256 -3 49 -3 50 -43 56 -23 4 -56 16 -75 27 -58 33 -73 34 -125 6z m126 -93 c64 -65 20 -171 -71 -171 -91 0 -135 106 -71 171 41 41 101 41 142 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 295 c-25 -24 -33 -59 -17 -69 5 -3 28 14 51 38 35 36 40 44 26 50 -27 10 -34 7 -60 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 235 c-38 -39 -41 -45 -25 -51 25 -10 68 16 79 49 18 50 -6 51 -54 2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessDenied);
export default __webpack_public_path__ + "static/media/access-denied.27cc6839.svg";
export { ForwardRef as ReactComponent };